import m from"../../../_snowpack/pkg/mdui/dist/js/mdui.esm.js";export default m;
